import { gql } from '@apollo/client';

export const WHOLE_ADDRESS_FRAGMENT = gql`
  fragment WholeAddressFragment on Address {
    streetAddress
    postCode
    city
  }
`;
